<template>
    <div>
        <div class="system-user-info" style="margin-left: 15px;">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>个人信息</span>
                </div>
                <div class="text item">
                    <div class="demo-type" style="height: 82px; width: 82px; line-height: 82px;padding-left: 160px;">
                        <el-avatar :size="60" style="height: 80px; width: 80px; line-height: 80px;">
                            <img :src="topJpg" />
                        </el-avatar>
                    </div>
                    <tr>
                        <svg-icon icon-class="user" />
                        <td style="width: 300px; height:25px">用户账号</td>
                        <td>{{ userInfo.username }}</td>
                    </tr>
                    <hr>
                    <tr>
                        <svg-icon icon-class="user" />
                        <td style="width: 300px; height:25px">用户姓名</td>
                        <td>{{ userInfo.nickName }}</td>
                    </tr>
                    <hr>
                    <tr>
                        <svg-icon icon-class="size" />
                        <td style="width: 300px;height:25px">用户性别</td>
                        <td>{{ userInfo.sex }}</td>
                    </tr>
                    <hr>
                    <tr>
                        <svg-icon icon-class="peoples" />
                        <td style="width: 300px;height:25px">联系方式</td>
                        <td>{{ userInfo.phonenumber }}</td>
                    </tr>
                    <hr>
                    <tr>
                        <svg-icon icon-class="tree" />
                        <td style="width: 300px;height:25px">所属部门</td>
                        <td>{{ userInfo.deptName }}</td>
                    </tr>
                    <hr>
                    <tr>
                        <svg-icon icon-class="peoples" />
                        <td style="width: 300px;height:25px">所属角色</td>
                        <td>{{ userInfo.roleNames }}</td>
                    </tr>
                    <hr>
                </div>
            </el-card>
        </div>
        <div class="system-user-pass" style="width: 500px;margin-left: 505px;margin-top: -482px;">
            <el-card class="box-card1">
                <div slot="header" class="clearfix1">
                    <span>修改密码</span>
                </div>
                <div class="text1 item1">
                    <el-form :model="passDto" status-icon :rules="rules" ref="passDto" label-width="100px"
                        class="demo-ruleForm">
                        <el-form-item label="旧密码" prop="password">
                            <el-input type="password" v-model="passDto.password" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPassword">
                            <el-input type="password" v-model="passDto.newPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="checkPassword">
                            <el-input type="password" v-model="passDto.checkPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm">提交</el-button>
                            <el-button @click="resetForm">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </div>
    </div>
</template>
<style lang="less" scoped>
.text {
    font-size: 15px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}


.box-card {
    width: 480px;
}

.text1 {
    font-size: 15px;
}

.item1 {
    margin-bottom: 18px;
}

.clearfix1:before,
.clearfix1:after {
    display: table;
    content: "";
}

.clearfix1:after {
    clear: both
}

.box-card1 {
    width: 480px;
}
</style>
<script>
import { updatePass, getUserInfo } from "@/api/admin-service/user"
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.passDto.checkPassword !== '') {
                    this.$refs.passDto.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passDto.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            topJpg: "",
            userInfo: {
                username: "",
                nickname: "",
                sex: "",
                phonenumber: "",
                deptName: "",
                roleNames: ""
            },
            passDto: {
                userId: "",
                password: "",
                newPassword: "",
                checkPassword: ""
            }
            ,
            rules: {
                password: [
                    { required: true, message: "旧密码不能为空", trigger: 'blur' }
                ],
                newPassword: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        submitForm() {
            this.$refs.passDto.validate((valid) => {
                if (valid) {
                    updatePass(this.passDto).then((data) => {
                        if (data.code === '200') {
                            this.$message({
                                showClose: true,
                                message: data.msg,
                                type: 'success'
                            });
                            // 回到首页
                            localStorage.removeItem("access_token");
                            this.$router.replace("/login");
                        } else {
                            this.$message({
                                showClose: true,
                                message: data.msg,
                                type: 'error'
                            });
                        }
                    })
                }
            });
        },
        resetForm() {
            this.$refs.passDto.resetFields();
        }
    },
    // 模板渲染完成以后才会被调用
    mounted() {
        getUserInfo().then((data) => {
            let info = JSON.parse(JSON.stringify(data.data))
            this.userInfo = info
            this.passDto.userId = info.userId
            this.userInfo.roleNames = info.roleList.map(role => role.roleName).join(',');
        })
    }

}

</script>